var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbNrSignallingOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-117 -1496) translate(117 1496)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.566 9.318c-2.505 0-4.536 1.753-4.536 3.914v10.781c0 2.161 2.031 3.914 4.536 3.914s4.534-1.753 4.534-3.914V13.232c0-2.161-2.029-3.914-4.534-3.914zm0 16.474a2 2 0 1 1 2.07-2 2.034 2.034 0 0 1-2.07 2zm0-5.174a2 2 0 1 1 2.07-2 2.034 2.034 0 0 1-2.07 2zm0-5.174a2 2 0 1 1 2.071-2 2.035 2.035 0 0 1-2.071 2z",
    transform: "translate(-117 -1496) translate(116.082 1494) translate(7.917 4) translate(-12.083 -8.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 4c-3.028 0-5.483 1.938-5.483 4.328v11.923c0 2.392 2.455 4.329 5.483 4.329s5.483-1.937 5.483-4.329V8.328C18.883 5.938 16.428 4 13.4 4zm4.715 15.741c0 2.187-2.115 3.959-4.715 3.959s-4.715-1.772-4.715-3.958V8.838c0-2.186 2.115-3.958 4.715-3.958s4.715 1.772 4.715 3.958z",
    transform: "translate(-117 -1496) translate(116.082 1494) translate(7.917 4) translate(-7.917 -4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNrSignallingOperations);
export default __webpack_public_path__ + "static/media/rb-nr-signalling-operations.c6e1fac4654909789b2ff725fe828813.svg";
export { ForwardRef as ReactComponent };